var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.351472 0.751863C0.820101 0.283233 1.5799 0.283233 2.04853 0.751863L6 4.70333L9.95147 0.751863C10.4201 0.283233 11.1799 0.283233 11.6485 0.751863C12.1172 1.22049 12.1172 1.98029 11.6485 2.44892L6.84853 7.24892C6.3799 7.71755 5.6201 7.71755 5.15147 7.24892L0.351472 2.44892C-0.117157 1.98029 -0.117157 1.22049 0.351472 0.751863Z",
    fill: "#5E6E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f14c26f3d9e1c66db8f0457d9f144e19.svg";
export { ForwardRef as ReactComponent };